module.exports = __webpack_public_path__ + "static/media/crypto-pay-home.99510232.png";